const defaultState = {
  status: "default",
  data: [],
  detail: {},
  idSiswa: "",
  code: 500,
  message: "",
};

let response = {};
const Siswa_lib = (state = defaultState, action = {}) => {
  switch (action.type) {
    case "SUCCESS_SISWA_SISWA":
      response = {
        ...state,
        data: action.data ? action.data : {},
        code: action.code ? action.code : 500,
        status: "success",

        message: action.message ? action.message : "",
      };

      break;
    case "SUCCESS_SISWA_DETAIL":
      response = {
        ...state,
        idSiswa: action.id ? action.id : "",
        detail: action.data ? action.data : {},
        code: action.code ? action.code : 500,
        status: "success",

        message: action.message ? action.message : "",
      };

      break;
    case "LOADING_SISWA_SISWA":
      response = {
        ...state,
        status: "loading",
      };
      break;
    case "ERROR_SISWA_SISWA":
      response = {
        ...state,
        status: "error",
        message: action.message ? action.message : "",
        code: action.code ? action.code : 500,
      };
      break;
    default:
      return {
        ...state,
      };
  }

  return response;
};

export default Siswa_lib;
